import { PayloadAction } from '@reduxjs/toolkit';
import { put } from 'redux-saga/effects';

import * as API from 'services';

import { formatDataMyPage } from './my-page.helper';
import { MyPageActions } from './my-page.redux';
import {
	IPayloadGetMyPageRequest,
	IPayloadUpdateDataMyPageRequest,
} from './my-page.type';

export function* getDataMyPage(
	action: PayloadAction<IPayloadGetMyPageRequest>
) {
	const { callback } = action?.payload || {};
	try {
		const res: API.ApiResponseSuccess<API.TDataMyPage> =
			yield API.getDataMyPage();

		yield put(
			MyPageActions.getDataMyPageSuccess({
				dataMyPage: formatDataMyPage(res?.data),
			})
		);
		yield callback?.({ data: formatDataMyPage(res?.data) });
	} catch (error) {
		callback?.({ error });
		yield put(MyPageActions.getDataMyPageFailure());
	}
}

export function* updateDataMyPageSaga(
	action: PayloadAction<IPayloadUpdateDataMyPageRequest>
) {
	const { callback, ...props } = action.payload;

	try {
		yield API.updateDataMyPage({
			...props,
		});

		yield put(MyPageActions.updateDataMyPageSuccess());
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(MyPageActions.updateDataMyPageFailure());
	}
}
